/**
 * Created by Mikhail Menshenin on 27.06.2025
 */

const KingsCupLevelsAdapter = {
    SubscribeToEvents: function () {
        if (!cleverapps.config.features.includes("kingscup")) {
            return;
        }

        cleverapps.eventBus.on("outcome", (outcome) => {
            if (outcome !== GameBase.OUTCOME_VICTORY) {
                return;
            }

            const points = KingsCupLevelsAdapter.calcVictoryPoints();
            if (points > 0) {
                cleverapps.personalBest.addPoint("kingscup", points);
            }

            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            if (!mission || !mission.isRunning() || mission.isCompleted()) {
                return;
            }

            if (!mission.logic.isUnlocked()) {
                mission.logic.readyToUnlock = true;
            } else if (points > 0) {
                mission.logic.earnPoints(points);
            }
        });

        cleverapps.eventBus.on("collectKingsCupMark", (value) => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_KINGSCUP);
            if (!mission || !mission.isRunning() || mission.isCompleted()) {
                return;
            }

            const game = Game.currentGame;
            game.rewards.kingsCup = (game.rewards.kingsCup || 0) + value;
        });

        cleverapps.missionManager.on("kingsCupStart", (mission) => {
            if (mission.getType() === Mission.TYPE_KINGSCUP) {
                cleverapps.focusManager.displayWhenFreeFocus({
                    focus: "KingsCupStartWindow_play",
                    action: function (f) {
                        Level.WantsToPlay(f);
                    }
                });
            }
        });
    },

    calcVictoryPoints: function () {
        if (["board", "match3"].includes(cleverapps.config.type)) {
            return Game.currentGame.rewards.kingsCup || 0;
        }

        return 1;
    }
};

cleverapps.whenAllInitialized(() => KingsCupLevelsAdapter.SubscribeToEvents());
